import { Store } from 'src/store/index';

const getFormatSelectorValues = (store: Store) => store.editor.formatSelectors;

export default getFormatSelectorValues;
